import * as actionTypes from "../constants/actionTypes";
import * as componentTypes from "../constants/componentTypes";
import * as rcc from "../constants/rcc";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";
import * as config from "../constants/config";
import * as messageHelper from "../helpers/messageHelper";

export const addNewTab = (type, scene) => ({
    type: actionTypes.ADD_NEW_TAB,
    payload: {
        type: type,
        scene: scene
    }
});

export const maxTabCountReached = () => messageHelper.getInfoMessageAction("flashMessage.maxTabs");

export const setActiveTab = (tabId) => ({
    type: actionTypes.SET_ACTIVE_TAB,
    payload: {
        tabId: tabId
    }
});

export const setActiveTabScene = (tabId, scene) => ({
    type: actionTypes.SET_ACTIVE_TAB_SCENE,
    payload: {
        tabId: tabId,
        scene: scene
    }
});

export const setCustomerHistoryTab = (customer) => ({
    type: actionTypes.OPEN_CUSTOMER_HISTORY_TAB,
    payload: {
        customer: customer
    }
});

export const closeActiveTab = (tabId, tabList, dispensingTabId, activeTabId = null) => {
    if (tabId === componentTypes.DEFAULT_TAB_ID) {
        return {
            type: actionTypes.CLOSE_ACTIVE_TAB,
            payload: {
                newActive: componentTypes.DEFAULT_TAB_ID,
                newTabList: tabList
            }
        };
    }

    const newTabList = tabList.filter((tab) => tab.id !== tabId || tab.id === dispensingTabId);

    if (activeTabId !== null) {
        return {
            type: actionTypes.CLOSE_ACTIVE_TAB,
            payload: {
                newActive: activeTabId,
                newTabList: newTabList
            }
        };
    }

    let newActiveId = tabId;

    if (newTabList.length < tabList.length) {
        newActiveId = componentTypes.DEFAULT_TAB_ID;

        for (let tab of tabList) {
            if (tab.id === tabId) {
                break;
            }

            newActiveId = tab.id;
        }
    }

    return {
        type: actionTypes.CLOSE_ACTIVE_TAB,
        payload: {
            newActive: newActiveId,
            newTabList: newTabList
        }
    };
};

export const closeAllTabs = (newTabList) => ({
    type: actionTypes.CLOSE_ALL_TABS,
    payload: {
        newTabList: newTabList
    }
});

export const closeAllTabsExceptActive = (newTabList) => ({
    type: actionTypes.CLOSE_ALL_TABS_EXCEPT_ACTIVE,
    payload: {
        newTabList: newTabList
    }
});

export const storeOpenedTabList = () => ({
    type: actionTypes.STORE_OPENED_TAB_LIST
});

export const changeTabOrder = (order) => ({
    type: actionTypes.CHANGE_TAB_ORDER,
    payload: {
        order: order
    }
});

export const showMenu = () => ({
    type: actionTypes.MENU_SHOW
});

export const hideMenu = () => ({
    type: actionTypes.MENU_HIDE
});

export const globalSearch = (search, local) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SEARCH_GLOBAL_FORMULAS,
        params: {
            search: search,
            rowCount: config.MAX_FORMULA_LIMIT,
            offset: 0,
            local: local
        }
    },
    method: handlers.SEARCH_GLOBAL_FORMULAS,
    tabId: 0
});

export const reloadGlobalSearch = (search, limit, offset, local) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_SEARCH_GLOBAL_FORMULAS,
        params: {
            search: search,
            rowCount: limit,
            offset: offset,
            local: local
        }
    },
    method: handlers.SEARCH_GLOBAL_FORMULAS_WITH_OFFSET,
    tabId: 0
});

export const selectFormula = (color, product, fandeck, base) => ({
    type: actionTypes.NAVIGATION_SELECT_FORMULA,
    payload: {
        tabId: null,
        color: color,
        product: product,
        fandeck: fandeck,
        base: base
    }
});

export const resetGlobalSearchFormulas = () => ({
    type: actionTypes.RESET_FORMULA_LIST
});

export const openHomeTab = () => ({
    type: actionTypes.OPEN_HOME_TAB
});

export const addNewOrOpenMainTab = () => ({
    type: actionTypes.MENU_ADD_NEW_OR_OPEN_MAIN_TAB
});

export const openOrResetMainTab = (scene) => ({
    type: actionTypes.MENU_ADD_NEW_OR_RESET_MAIN_TAB,
    payload: {
        scene: scene
    }
});

export const addNewOrOpenColorPaletteTab = () => ({
    type: actionTypes.MENU_ADD_NEW_OR_OPEN_COLOR_PALETTE_TAB
});

export const addNewOrOpenColorSearchTab = () => ({
    type: actionTypes.MENU_ADD_NEW_OR_OPEN_COLOR_SEARCH_TAB
});

export const addNewOrOpenCustomTab = () => ({
    type: actionTypes.MENU_ADD_NEW_OR_OPEN_CUSTOM_TAB
});

export const saveFormulaAsCustom = (tabId) => ({
    type: actionTypes.SAVE_FORMULA_AS_CUSTOM,
    payload: {
        tabId: tabId
    }
});

export const addNewFavoritesTab = () => ({
    type: actionTypes.MENU_ADD_NEW_FAVORITES_TAB
});

export const addNewCanistersTab = () => ({
    type: actionTypes.MENU_ADD_NEW_CANISTERS_TAB
});

export const addNewSpectroTab = () => ({
    type: actionTypes.MENU_ADD_NEW_SPECTRO_TAB
});

export const addNewStatisticsTab = () => ({
    type: actionTypes.MENU_ADD_NEW_STATISTICS_TAB
});

export const addNewCustomersTab = () => ({
    type: actionTypes.MENU_ADD_NEW_CUSTOMERS_TAB
});

export const addNewMatchingTab = (id, scene, overwrite, product) => ({
    type: actionTypes.MENU_ADD_NEW_MATCHING_TAB,
    payload: {
        id: id,
        scene: scene,
        overwrite: overwrite,
        product: product
    }
});

export const addNewTicketingTab = () => ({
    type: actionTypes.MENU_ADD_NEW_TICKETING_TAB
});

export const addNewMyOrdersTab = () => ({
    type: actionTypes.MENU_ADD_NEW_MY_ORDERS_TAB
});

export const addNewToDispenseTab = () => ({
    type: actionTypes.MENU_ADD_NEW_TO_DISPENSE_TAB
});

export const addNewBugReportTab = () => ({
    type: actionTypes.MENU_ADD_NEW_BUG_REPORT_TAB
});

export const addNewGlobalSearchTab = () => ({
    type: actionTypes.MENU_ADD_NEW_GLOBAL_SEARCH_TAB
});

export const addNewOrdersHistoryTab = () => ({
    type: actionTypes.MENU_ADD_NEW_ORDERS_HISTORY_TAB
});

export const setMenuItem = (item, submenuItem = null) => ({
    type: actionTypes.MENU_SET_MENU_ITEM,
    payload: {
        item: item,
        submenuItem: submenuItem
    }
});

export const setSubmenuItem = (submenuItem) => ({
    type: actionTypes.MENU_SET_SUBMENU_ITEM,
    payload: {
        submenuItem: submenuItem
    }
});

export const openModal = (tabId, type) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: tabId,
        type: type
    }
});

export const openJustOneModal = (tabId, type) => ({
    type: actionTypes.NAVIGATION_OPEN_JUST_ONE_MODAL,
    payload: {
        tabId: tabId,
        type: type,
        style: componentTypes.MODAL_DEFAULT_STYLE
    }
});

export const openModalWithParams = (tabId, type, params) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: tabId,
        type: type,
        params: params
    }
});

export const openSettingsModal = (type) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: componentTypes.MODAL_SETTINGS_TAB,
        type: type
    }
});

export const openSettingsModalWithParams = (type, params) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: componentTypes.MODAL_SETTINGS_TAB,
        type: type,
        params: params
    }
});

export const closeModal = (type) => ({
    type: actionTypes.NAVIGATION_CLOSE_MODAL,
    payload: {
        type: type
    }
});

export const closeAllModals = () => ({
    type: actionTypes.NAVIGATION_CLOSE_ALL_MODALS
});

export const openScreenSaver = () => ({
    type: actionTypes.NAVIGATION_OPEN_SCREENSAVER
});

export const closeScreenSaver = () => ({
    type: actionTypes.NAVIGATION_CLOSE_SCREENSAVER
});

export const closeRedlikeWindow = () => ({
    type: actionTypes.NAVIGATION_CLOSE_REDLIKE_WINDOW
});

export const setBlockedUi = (blocked) => ({
    type: actionTypes.SET_BLOCKED_UI,
    payload: {
        blocked: blocked
    }
});

export const setAutomaticMainTabScene = (tabId) => ({
    type: actionTypes.SET_AUTOMATIC_MAIN_TAB_SCENE,
    payload: {
        tabId: tabId
    }
});

export const openNewMainTab = (tabId, reset, packageCount = null, colorStatsId = null, manualCorrection = false) => ({
    type: actionTypes.OPEN_NEW_MAIN_TAB,
    payload: {
        tabId: tabId,
        reset: reset,
        packageCount: packageCount,
        colorStatsId: colorStatsId,
        manualCorrection: manualCorrection
    }
});

export const processKeyboardEvent = (keyboardEvent) => ({
    type: actionTypes.PROCESS_KEYBOARD_EVENT,
    payload: {
        keyboardEvent: keyboardEvent
    }
});

export const setCustomSearch = (value) => ({
    type: actionTypes.SET_GLOBAL_CUSTOM_SEARCH,
    payload: {
        customSearch: value
    }
});

export const openHelpModal = () => ({
    type: actionTypes.NAVIGATION_OPEN_HELP_MODAL
});

export const setNotificationPanel = (value) => ({
    type: actionTypes.NAVIGATION_SET_NOTIFICATION_PANEL,
    payload: {
        activeNotificationPanel: value
    }
});

export const deleteFlashMessage = (id) => ({
    type: actionTypes.DELETE_FLASH_MESSAGE,
    payload: {
        deletedItem: id
    }
});

export const deleteAllFlashMessages = () => ({
    type: actionTypes.DELETE_ALL_FLASH_MESSAGES
});

export const winterPluginMessage = () => messageHelper.getInfoMessageAction("flashMessage.disableWinterPlugin");

export const successMessage = (messageKey) => messageHelper.getSuccessMessageAction(messageKey);

export const deleteItemConfirmation = (tabId, action, dialog = null) => ({
    type: actionTypes.DELETE_ITEM_CONFIRMATION,
    payload: {
        tabId: tabId,
        dialog: dialog,
        next: action
    }
});

export const userAuthentication = (tabId, action) => ({
    type: actionTypes.USER_AUTHENTICATION,
    payload: {
        tabId: tabId,
        next: action
    }
});

export const openConfirmationModal = (
    tabId,
    action,
    dialog = null,
    confirmBtn = null,
    hideMessageSuffix = false,
    showCustomConfirmBtnIcon = false
) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: tabId,
        type: componentTypes.CONFIRMATION_MODAL,
        params: {
            next: action,
            dialog: dialog,
            confirmBtn: confirmBtn,
            hideMessageSuffix: hideMessageSuffix,
            showCustomConfirmBtnIcon: showCustomConfirmBtnIcon
        }
    }
});

export const openCheckBeforeDispensingModal = (tabId, action, realColorantList, numCanToDispense) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: tabId,
        type: componentTypes.CHECK_BEFORE_DISPENSING_MODAL,
        params: {
            next: action,
            realColorantList: realColorantList,
            numCanToDispense: numCanToDispense
        }
    }
});

export const openBeforeDispenseColorantBatchModal = (tabId, action, colorants) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: tabId,
        type: componentTypes.BEFORE_DISPENSE_COLORANT_BATCH_MODAL,
        params: {
            next: action,
            colorants: colorants
        }
    }
});

export const openRefillConfirmationModal = (tabId, index, level, add, unitMl, type = rcc.RCC_REFILL) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: tabId,
        type: componentTypes.REFILL_CONFIRMATION_MODAL,
        params: {
            index: index,
            level: level,
            add: add,
            unitMl: unitMl,
            type: type
        }
    }
});

export const setActiveTutorial = (tutorial) => ({
    type: actionTypes.NAVIGATION_SET_ACTIVE_TUTORIAL,
    payload: {
        tutorial: tutorial
    }
});

export const disableTutorial = (tutorial) => ({
    type: actionTypes.NAVIGATION_DISABLE_TUTORIAL,
    payload: {
        tutorial: tutorial
    }
});

export const finishTutorial = (tutorial) => ({
    type: actionTypes.NAVIGATION_FINISH_TUTORIAL,
    payload: {
        tutorial: tutorial
    }
});

export const setRender = (rendered) => ({
    type: actionTypes.SET_RENDER,
    payload: {
        rendered: rendered
    }
});

export const windowResized = () => ({
    type: actionTypes.WINDOW_RESIZED
});

export const hideAllDialogs = () => ({
    type: actionTypes.HIDE_ALL_DIALOGS
});

export const toggleRccDialog = () => ({
    type: actionTypes.TOGGLE_RCC_DIALOG
});

export const toggleSpectroDialog = () => ({
    type: actionTypes.TOGGLE_SPECTRO_DIALOG
});

export const toggleMessageDialog = () => ({
    type: actionTypes.TOGGLE_MESSAGE_DIALOG
});

export const cancelMessageDialog = () => ({
    type: actionTypes.CANCEL_MESSAGE_DIALOG
});

export const cancelAllMessageDialogs = () => ({
    type: actionTypes.CANCEL_ALL_MESSAGE_DIALOGS
});

export const openLoadingModal = (tabId, message, cancelHandler) => ({
    type: actionTypes.NAVIGATION_OPEN_MODAL,
    payload: {
        tabId: tabId,
        type: componentTypes.LOADING_MODAL,
        params: {
            message: message,
            onCancel: cancelHandler
        }
    }
});

export const skipRequest = (tabId, handler) => ({
    type: actionTypes.SKIP_WEBSOCKET_REQUEST,
    payload: {
        tabId: tabId,
        method: handler
    }
});

export const setValidationFlashMessage = () => {
    return messageHelper.getErrorMessageAction("flashMessage.keyboardShortcutValidation");
};

export const getHelpValidationMessage = (wrongInput) => {
    return messageHelper.getErrorMessageAction("flashMessage.wrongHelpInput", [wrongInput]);
};
